import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './messages';
import Proxy from 'es6-proxy-polyfill';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import duration from 'dayjs/plugin/duration';
import localeMap from './localeMap';
import { CacheLanguage } from '@zk/framework-vue';
import http from 'common-module/src/util/http';
import config from 'common-module/src/config';
import { snakeCase, camelCase, kebabCase, lowerCase, lowerFirst, upperFirst } from 'lodash';
                 
        
                               
         
import { getDateFormat } from './dateformat.js';

dayjs.extend(isToday);
dayjs.extend(duration);

Vue.use(VueI18n);

const eventMap = new Map();
// 海外版
                 
// eslint-disable-next-line
         export const getLanguage = () => 'en';
        
                                  
                                                                  
                                   
                
   
              
   
         

const locale = getLanguage();
const pluralizationRule = (choice, choicesLength) => {
  choice = Math.abs(choice);

  if (choicesLength === 2) {
    return choice
      ? choice > 1
        ? 1
        : 0
      : 1;
  }

  return choice ? Math.ceil(Math.min(choice, 2)) : 0;
};
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale,
  fallbackLocale: 'zh',
  // set locale messages
  messages,
  pluralizationRules: {
    zh: pluralizationRule,
    en: pluralizationRule
  },
  missing: (locale, key) => {
    const isProd = ['prod', 'sit', 'pre'].includes(config.VUE_APP_ENV);
    return isProd ? '...' : key;
  },
  modifiers: {
    // eslint-disable-next-line spellcheck/spell-checker
    snakecase: snakeCase,
    // eslint-disable-next-line spellcheck/spell-checker
    camelcase: camelCase,
    // eslint-disable-next-line spellcheck/spell-checker
    kebabcase: kebabCase,
    lowercase: lowerCase,
    // eslint-disable-next-line spellcheck/spell-checker
    lowerfirst: lowerFirst,
    // eslint-disable-next-line spellcheck/spell-checker
    upperfirst: upperFirst
  }
});

const setLocale = locale => {
  console.log(`set locale is ${locale}`);
  dayjs.locale(locale);
  eventMap.get('change')?.forEach(fn => fn(locale, localeMap[locale], localeMap));
};

const proxy = new Proxy(i18n, {
  set (target, p, value, r) {
    if (p === 'locale' && target[p] !== value) {
      setLocale(value);
    }
    Reflect.set(target, p, value, r);
    return true;
  }
});

setLocale(locale);
proxy.dateFormat = getDateFormat(locale);

proxy.on = (event, fn) => {
  let fnSet = eventMap.get(event);
  if (!fnSet) {
    fnSet = new Set();
    eventMap.set(event, fnSet);
  }
  fnSet.add(fn);
};

proxy.off = (event, fn) => {
  const fnSet = eventMap.get(event);
  fnSet && fnSet.delete(fn);
};

// 公共翻译，不鉴权
export const commonCacheLanguage = new CacheLanguage(proxy, () => window.i18nData, {
  transformData: data => CacheLanguage.processData(data, { key: 'k', value: 'v' }),
  locale: proxy.locale,
  cache: false
});

// 租户翻译，需要权限
let orgCacheLanguage;
export const getOrgCacheLanguage = (orgId, token) => {
  if (orgCacheLanguage && orgCacheLanguage.__orgId !== orgId) {
    orgCacheLanguage.clearCache();
    orgCacheLanguage.destroy();
    orgCacheLanguage = null;
  }
  if (!orgCacheLanguage) {
    orgCacheLanguage = new CacheLanguage(proxy, (messageLang) => http.post('/language/translation-simple', { messageLang }, {
      headers: {
        accesstoken: token
      }
    }), {
      cacheKey: `language-cache-${orgId}`,
      transformData: data => CacheLanguage.processData(data, { key: 'k', value: 'v' }),
      locale: proxy.locale
    });
    orgCacheLanguage.__orgId = orgId;
  }
  return orgCacheLanguage;
};

export const loadAllLanguage = (orgId, locale, token, refresh = false) => {
  token && getOrgCacheLanguage(orgId, token);
  return CacheLanguage.loadByGroup(proxy, locale, refresh);
};

export default proxy;
